<template>
	<section class="content-header bg-green-custom m-0 font-weight-bold">
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-6">
					<h4 v-if="title">
						<i :class="icon" v-if="icon"></i>
						{{ title }}
					</h4>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: null,
		},
		icon: {
			type: String,
			default: null,
		},
	},
	beforeMount() {
		let title = this.$store.state.app.name;
		title = this.title ? `${this.title} | ${title}` : title;
		$("title").html(title);
	},
};
</script>

<style>
.content-header {
	font-family: NunitoBlack;
	color: white !important;
}
</style>